import { render, staticRenderFns } from "./itemStockCreateModal.vue?vue&type=template&id=2d7dbec8&"
import script from "./itemStockCreateModal.vue?vue&type=script&lang=ts&"
export * from "./itemStockCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports